

class CashDeskSessionCountCell extends UITableViewCell
{
    private iconView:MUIImageView = null;
    private titleLabel:MUILabel = null;
    private estimatedLabel:MUILabel = null;
    private tipsLabel:MUILabel = null;
    private countedTextField:MUITextField = null;
    private tipsCountedTextField:MUITextField = null;

    private cf:MIONumberFormatter = MUIWebApplication.sharedInstance().delegate.currencyFormatter;

    awakeFromHTML(){
        //this.iconView = MUIOutlet(this, "icon-view", "MUIImageView");
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.estimatedLabel = MUIOutlet(this,"estimated-lbl", "MUILabel");
        this.tipsLabel = MUIOutlet(this,"tips-lbl", "MUILabel");
        
        this.countedTextField = MUIOutlet(this, "counted-tf", "MUITextField");        
        this.countedTextField.formatter = this.cf;
        this.countedTextField.setOnChangeText(this, function(control, value){
            let newValue = this.cf.numberFromString(value);            
            this.item["countedMoney"] = newValue;
        });

        this.tipsCountedTextField = MUIOutlet(this, "counted-tips-tf", "MUITextField");
        this.tipsCountedTextField.formatter = this.cf;
        this.tipsCountedTextField.setOnChangeText(this, function(control, value){
            let newValue = this.cf.numberFromString(value);
            this.item["countedTips"] = newValue;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }
    
    private item = null;
    setItem(item:any){
        this.item = item;

        //this.iconView.setImage(item["paymethodimageurl"]);
        this.titleLabel.text = item["paymethodName"];
        this.estimatedLabel.text = this.cf.stringFromNumber(item["estimatedMoney"]);
        this.tipsLabel.text = this.cf.stringFromNumber(item["estimatedTips"]);
        this.countedTextField.text = this.cf.stringFromNumber(item["countedMoney"]);
        this.tipsCountedTextField.text = this.cf.stringFromNumber(item["countedTips"]);
    }

}